import { Directive, Output, HostListener, EventEmitter } from '@angular/core';
declare var $: any;

// tslint:disable-next-line:directive-selector
@Directive({ selector: '[containerMouseWheel]' })
export class ContainerWheelDirective {
  @Output() mouseWheelUp = new EventEmitter();
  @Output() mouseWheelDown = new EventEmitter();

  @HostListener('mousewheel', ['$event']) onMouseWheelChrome(event: any) {
    // console.log(event)
    this.mouseWheelFunc(event);
  }

  @HostListener('DOMMouseScroll', ['$event']) onMouseWheelFirefox(event: any) {
    this.mouseWheelFunc(event);
  }

  @HostListener('onmousewheel', ['$event']) onMouseWheelIE(event: any) {
    this.mouseWheelFunc(event);
  }

  mouseWheelFunc(event: any) {
    console.log(event.deltaY)
    let delta = event.deltaY;
    if (delta < 0) { delta = -280 } else { delta = 280 }

    $('.CardsContainer').scrollLeft($('.CardsContainer').scrollLeft() + (delta));



  }
}
// tslint:disable-next-line:directive-selector
@Directive({ selector: '[listMouseWheel]' })
export class ListWheelDirective {
  @Output() mouseWheelUp = new EventEmitter();
  @Output() mouseWheelDown = new EventEmitter();

  @HostListener('mousewheel', ['$event']) onMouseWheelChrome(event: any) {
    // console.log(event)
    this.mouseWheelFunc(event);
  }

  @HostListener('DOMMouseScroll', ['$event']) onMouseWheelFirefox(event: any) {
    this.mouseWheelFunc(event);
  }

  @HostListener('onmousewheel', ['$event']) onMouseWheelIE(event: any) {
    this.mouseWheelFunc(event);
  }

  mouseWheelFunc(event: any) {

    event.stopPropagation();



  }
}






// WEBPACK FOOTER //
// C:/Websites/Planeto/PlanetoAngular/src/app/app.mousewheel.directive.ts